<div class="fm-authentication">
  <div class="container-fluid fm-container-full">
    <div class="row h-100 justify-content-center align-items-center">
      <div class="col-sm-10 col-md-8 col-lg-6 col-xl-5">
        <div class="fm-auth-card">

          <!-- Logo -->
          <div class="fm-auth-chead">
            <div class="fm-logo">
              <a routerLink="/"><img src="images/logo.svg" width="213" alt="Forever Memories" /></a>
            </div>
          </div>

              <!-- ── LOADING / VERIFYING ── -->
              @if (isLoading()) {
                <div class="fm-invitation-state text-center py-4">
                  <div class="fm-inv-icon-wrap fm-inv-icon-verifying mb-3">
                    <div class="fm-inv-spinner"></div>
                  </div>
                  <h3 class="fm-head-28 fm-head-sty2 fw-bold mb-2">Verifying Your Email</h3>
                  <p class="mb-0">Please wait while we verify your email address…</p>
                </div>
              }

              <!-- ── SUCCESS ── -->
              @if (isVerified()) {
                <div class="fm-invitation-state text-center py-4">
                  <div class="fm-inv-icon-wrap fm-inv-icon-success mb-3">
                    <img src="images/icons/fm-check.svg" class="fm-svg fm-inv-state-icon" alt="Success" />
                  </div>
                  <h3 class="fm-head-28 fm-head-sty2 fw-bold mb-2">Email Verified!</h3>
                  <p class="mb-3">Your email has been verified successfully. Redirecting you to set up your Family Space…</p>
                  <p class="text-muted small mb-0">Redirecting in {{ countdown() }} seconds…</p>
                  <a routerLink="/create-family-space" class="fm-common-btn mt-4 d-inline-flex">Continue Setup</a>
                </div>
              }

              <!-- ── FAILED / ERROR ── -->
              @if (isFailed()) {
                <div class="fm-invitation-state text-center py-4">
                  <div class="fm-inv-icon-wrap fm-inv-icon-error mb-3">
                    <img src="images/icons/fm-logout.svg" class="fm-svg fm-inv-state-icon" alt="Error" />
                  </div>
                  <h3 class="fm-head-28 fm-head-sty2 fw-bold mb-2">Verification Failed</h3>
                  <p class="fm-inv-error-msg mb-3">{{ errorMessage() }}</p>
                  <p class="text-muted small mb-0">Redirecting to login in {{ countdown() }} seconds…</p>
                  <a routerLink="/login" class="fm-common-btn mt-4 d-inline-flex">Go to Login</a>
                </div>
              }

              <!-- ── MANUAL RESEND ── -->
              @if (!isLoading() && !isVerified() && !isFailed()) {
                <div class="fm-auth-chead mt-0 pt-0">
                  <h3 class="fm-head-28 fm-head-sty2 fw-title fw-bold">Verify Your Email</h3>
                  <p>We've sent a verification link to your email. Please click the link to verify your account.</p>
                </div>

                <div class="fm-signin-form">
                  <p class="text-muted mb-3">Didn't receive the email or link expired?</p>
                  <form [formGroup]="resendForm" (ngSubmit)="onResendVerification()" novalidate>
                    <fieldset class="row g-3 g-sm-4">
                      <div class="col-12">
                        <div class="form-group">
                          <label class="fm-label">Email Address <span class="fm-required">*</span></label>
                          <input
                            type="email"
                            placeholder="Enter your email address"
                            class="form-control"
                            [class.is-invalid]="f['email'].invalid && f['email'].touched"
                            formControlName="email"
                            autocomplete="email" />
                          @if (f['email'].errors?.['required'] && f['email'].touched) {
                            <div class="invalid-feedback">Email is required.</div>
                          }
                          @if (f['email'].errors?.['email'] && f['email'].touched) {
                            <div class="invalid-feedback">Please enter a valid email.</div>
                          }
                        </div>
                      </div>
                      <div class="col-12">
                        <button
                          class="fm-common-btn w-100 mt-2 mt-lg-3"
                          type="submit"
                          [disabled]="isLoading()">
                          @if (isLoading()) {
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>Sending…
                          } @else {
                            Resend Verification Link
                          }
                        </button>
                      </div>
                      <div class="col-12 text-center">
                        <p class="text-muted small mb-0">
                          Remember your password?
                          <a routerLink="/login" class="fm-basic-link">Back to Sign In</a>
                        </p>
                      </div>
                    </fieldset>
                  </form>
                </div>
              }

        </div>
      </div>
    </div>
  </div>
</div>
